export default {"src":"/_next/static/media/refresh.97b0782f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};